import { Environment } from './environment';

/**
 * Attempts to determine the environment of the webapp using the environment
 * variables;
 *
 * @returns { string }
 */
export function getEnvFromEnvVariables() {
    switch ( process.env.NODE_ENV ) {
        case 'production':
            return Environment.PROD;
        case 'development':
            return Environment.DEV;
        default:
            return Environment.UNKNOWN;
    }
}

/**
 * Strings that can exist in the domain for the app to recognize it is in
 * the PROD environment.
 */
const PROD_DOMAIN_IDENTIFIERS = [
    'hoyavisionlearningcenter',
    'academy.seikovision',
];

/**
 * Attempts to determine the environment a webapp is being run in by looking
 * at its domain name.
 * 
 * @param { string } domainName - The domain name to check.
 * @returns { string }
 */
export function getEnvFromDomainName( domainName ) {
    // Validate the argument.
    if ( !domainName || typeof domainName !== 'string' || domainName.length <= 1 ) {
        return Environment.UNKNOWN;
    }

    // Check to see if we are in the PROD environment before checking for the other
    // environments since the URL for PROD is unique.
    const containsProdIdentifier = PROD_DOMAIN_IDENTIFIERS.some( ( identifier ) => domainName.includes( identifier ) );
    if ( containsProdIdentifier ) {
        return Environment.PROD;
    }

    // Grab the first token in the provided domain name (seperated by '.') and check
    // to see if that matches any known environments we have set up. This may be in
    // two different formats: `env` or `env-brand`. We only care about the environment
    // value.
    const potentialEnv = domainName?.toLowerCase()?.split( '.' )?.[ 0 ]?.split( '-' )?.[ 0 ];
    
    switch ( potentialEnv ) {
        case Environment.LOCAL: {
            return Environment.LOCAL;
        }
        case Environment.DEV: {
            return Environment.DEV;
        }
        case Environment.QA: {
            return Environment.QA;
        }
        case Environment.PPRD: {
            return Environment.PPRD;
        }
        case Environment.PROD: {
            return Environment.PROD;
        }
        default: {
            console.warn( `Unexpected domain name '${ domainName }'` );
            return Environment.UNKNOWN;
        }
    }
}
